@use "~theme/typographyV2" as typography;

.thankYou {
  position: relative;
}

.note {
  padding-bottom: 15px;
  text-align: center;
  font-family: typography.$font-mont;
}

.close {
  position: absolute;
  top: -30px;
  right: 0;
}

.button {
  width: 100%;
}
